// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/checkbox-circle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FreemiumMain_cards__0WeDd {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.FreemiumMain_price__59e1t {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-radius: 12px;
  background: #4343ff;
  color: #fff;
}
.FreemiumMain_price-description__8RrXV {
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
}

.FreemiumMain_product__7mDVS {
  padding: 20px;
  border-radius: 12px;
  background: #fff;
  color: #00007a;
}
.FreemiumMain_product-title__ZOU49 {
  margin-bottom: 12px;
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
}
.FreemiumMain_product-description__XKSW7 {
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
}

.FreemiumMain_logo__UzLZa {
  margin-right: 8px;
}

.FreemiumMain_collapsible-card__Z2E\\+N {
  padding: 20px;
  background: #fff;
}

.FreemiumMain_list__D64MF {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  margin: 0;
  padding: 0;
}
.FreemiumMain_list-title__cZOTv {
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
  color: #00007a;
}

.FreemiumMain_item__W2Dpd {
  display: flex;
  align-items: baseline;
}
.FreemiumMain_item__W2Dpd:before {
  content: "";
  display: inline-block;
  width: 17px;
  min-width: 17px;
  height: 17px;
  margin-right: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  vertical-align: top;
  transform: translateY(4px);
}

.FreemiumMain_button__ibiZ- {
  width: 240px;
}

.FreemiumMain_link__Nq6gs {
  width: 360px;
  text-align: center;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  color: #000078;
}

@media screen and (max-width: 600px) {
  .FreemiumMain_link__Nq6gs {
    width: 100%;
    text-align: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Freemium/FreemiumMain/FreemiumMain.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBCdS;EDeT,WAAA;AAIF;AAFE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAIJ;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cCxBS;AD2BX;AADE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAGJ;AAAE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAEJ;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;AACF;AACE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC/DO;ADgEX;;AAGA;EACE,aAAA;EACA,qBAAA;AAAF;AAEE;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mDAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AAAJ;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC5FU;AD2FZ;;AAIA;EACE;IACE,WAAA;IACA,mBAAA;EADF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.price {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  border-radius: 12px;\n  background: colors.$primary4;\n  color: #fff;\n\n  &-description {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n  }\n}\n\n.product {\n  padding: 20px;\n  border-radius: 12px;\n  background: #fff;\n  color: colors.$primary8;\n\n  &-title {\n    margin-bottom: 12px;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n  }\n\n  &-description {\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 28px;\n  }\n}\n\n.logo {\n  margin-right: 8px;\n}\n\n.collapsible-card {\n  padding: 20px;\n  background: #fff;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n  margin: 0;\n  padding: 0;\n\n  &-title {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n    color: colors.$primary8;\n  }\n}\n\n.item {\n  display: flex;\n  align-items: baseline;\n\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 17px;\n    min-width: 17px;\n    height: 17px;\n    margin-right: 10px;\n    background: url(../../../assets/checkbox-circle.svg);\n    background-size: cover;\n    vertical-align: top;\n    transform: translateY(4px);\n  }\n}\n\n.button{\n  width: 240px;\n}\n\n.link {\n  width: 360px;\n  text-align: center;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n  color: colors.$primary11;\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .link {\n    width: 100%;\n    text-align: initial;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"cards": `FreemiumMain_cards__0WeDd`,
	"price": `FreemiumMain_price__59e1t`,
	"price-description": `FreemiumMain_price-description__8RrXV`,
	"product": `FreemiumMain_product__7mDVS`,
	"product-title": `FreemiumMain_product-title__ZOU49`,
	"product-description": `FreemiumMain_product-description__XKSW7`,
	"logo": `FreemiumMain_logo__UzLZa`,
	"collapsible-card": `FreemiumMain_collapsible-card__Z2E+N`,
	"list": `FreemiumMain_list__D64MF`,
	"list-title": `FreemiumMain_list-title__cZOTv`,
	"item": `FreemiumMain_item__W2Dpd`,
	"button": `FreemiumMain_button__ibiZ-`,
	"link": `FreemiumMain_link__Nq6gs`
};
export default ___CSS_LOADER_EXPORT___;
